import { countriesByCodeWithSubdivisions, type Country, type NavItemNoIcon, navItemType } from '@cx-web/domain-types';

export const getCountriesWithSubdivisions = (items: NavItemNoIcon[]): Country[] => {
  return (items || []).reduce<Country[]>((acc, item) => {
    if (
      item.type === navItemType.STATE_SELECTOR &&
      item.countryCode &&
      item.countryCode in countriesByCodeWithSubdivisions
    ) {
      acc.push(countriesByCodeWithSubdivisions[item.countryCode]);
    }
    return acc;
  }, []);
};
